import React from 'react';

// Material ui
import { IconButton as MaterialIconButton, IconButtonProps } from '@material-ui/core';

import './IconButton.scss';

const IconButton: React.FC<IconButtonProps> = (props: IconButtonProps) => {

    return (
        <>
            <MaterialIconButton
                classes={{
                    root: 'ui-Icon-button-component'
                }}
                disableRipple
                disableFocusRipple
                disableTouchRipple
                {...props}
            />
        </>
    );
};

export default IconButton;